// Homepage js

export default {
  init() {
    // JavaScript to be fired on the home page
  },

  finalize() {
    // JavaScript fired after the init JS
  },

  unload() {
    // JavaScript to clean up before live page reload
  },
};
